"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Section = (0, styled_components_1.default)('div') `
  margin-left: 52px;
  border-radius: 24px 0 0 0;
  padding: 32px 24px;
  background: ${({ theme }) => theme.colors.BACKGROUND};
  min-height: calc(100vh - 84px);

  ${({ theme }) => theme.media.sm} {
    margin-left: 0;
  }
`;
